import Controller from '@ember/controller';
import { notEmpty } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import type ContactModel from 'donor-elf-web/models/contact';
import type { GroupIndexRouteModel } from 'donor-elf-web/routes/funds/fund/groups/group/index';
import type ContactsCache from 'donor-elf-web/services/contacts-cache';

interface GroupAddRouteModel extends GroupIndexRouteModel {
  contactsNotInGroup: ContactModel[];
}

export default class GroupAddController extends Controller {
  declare model: GroupAddRouteModel;

  @service declare contactsCache: ContactsCache;

  @tracked q = '';
  @tracked sortBy = ['name:asc'];

  get filterApplied() {
    return notEmpty('q');
  }

  get sortedContacts() {
    return sortByProperties(
      this.model.contactsNotInGroup,
      this.sortBy,
    ) as ContactModel[];
  }

  get filteredContacts() {
    const sortedContacts = this.sortedContacts;
    const q = this.q;

    if (isEmpty(q) || q.length < 2) {
      return sortedContacts;
    }

    const matchingContactIds: Record<string, boolean> = {};
    this.contactsCache.search(q).forEach((contact: ContactModel) => {
      matchingContactIds[contact.id] = true;
    });

    return sortedContacts.filter((contact: ContactModel) => {
      return matchingContactIds[contact.id];
    });
  }

  reset() {
    this.q = '';
  }

  applyFilter = (q: string) => {
    this.q = q.trim();
  };

  handleAddedToGroup = (contact: ContactModel) => {
    const index = this.model.contactsNotInGroup.indexOf(contact);

    if (index === -1) {
      return;
    }

    this.model.contactsNotInGroup.splice(index, 1);
  };
}
